import { defineStore } from "pinia";

export const useFavourites = defineStore("favourite", {
  state: () => ({
    favouriteList: JSON.parse(localStorage.getItem("favouriteList")) || [],
    favouriteId: JSON.parse(localStorage.getItem("favouriteId")) || [],
  }),
  persist: true,
  getters: {
    getFavouriteList(state) {
      return state.favouriteList;
    },
    getFavouriteId(state) {
      return state.favouriteId;
    },
  },
  actions: {
    setFavourite(e) {
      this.favouriteList.push(e);
      this.favouriteId.push(e.id);
      
    },
    deleteFavourite(e) {
      const index = this.favouriteList.findIndex((item) => item.id === e.id);
      if (index !== -1) {
        this.favouriteList.splice(index, 1);
        this.favouriteId.splice(index, 1);
      }
    },
    toggleFavourite(e) {
      const isFavourite = this.favouriteList.some((item) => item.id === e.id);

      if (!isFavourite) {
        this.setFavourite(e);
      } else {
        this.deleteFavourite(e);
      }
    },
  },
});
